import { useContext } from 'react';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from 'ui-product-approvals-common/constants/approvalTypeIds';
import { useListApprovalSettingsAssetsQuery } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsMetadataRpc.hooks';
import { AddTeamApproversFooter } from '../components/AddTeamApproversFooter';
import { ACTOR } from '../constants/actors';
import { SCOPES } from '../constants/auth';
import { ApprovalContext } from '../context/approvalContext';
import { useGetHasScope } from './useGetHasScope';
import { jsx as _jsx } from "react/jsx-runtime";
export const useAddTeamApproversFooter = (approvers, {
  enabled = true
} = {}) => {
  const entity = useContext(ApprovalContext);
  const getHasScope = useGetHasScope();
  const canEditApproverSettings = getHasScope(SCOPES.SUPER_ADMIN) || getHasScope(SCOPES.PARTNER_ADMIN);
  const shouldFetch = enabled && canEditApproverSettings;
  const {
    data
  } = useListApprovalSettingsAssetsQuery({
    skip: !shouldFetch || !entity
  });
  if (!shouldFetch || !entity) {
    return undefined;
  }
  const {
    approvalType,
    approvalAction
  } = entity.meta;
  const isTeamApproverEnabledForType = Boolean(data === null || data === void 0 ? void 0 : data.assets.some(asset => asset.objectTypeId === APPROVAL_TYPE_TO_OBJECT_TYPE_ID[approvalType] && asset.approvalAction === approvalAction && asset.teamApproverEnabled));
  const hasTeamApprovers = approvers.some(approver => approver.actor.actorType === ACTOR.TEAM);
  return isTeamApproverEnabledForType && !hasTeamApprovers ? /*#__PURE__*/_jsx(AddTeamApproversFooter, {}) : undefined;
};